import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import { featureEnabled } from 'helpers/ToggleBot';

import { getProperties, getUnits, showUnits } from 'actions/landlordPropertiesActions';
import {
  fetchProject,
  putProject,
  fetchFilteredProjectTickets,
  linkTicketToProject,
  unlinkTicketFromProject,
  fetchFilteredProjectPurchaseOrders,
  linkPurchaseOrderToProject,
  unlinkPurchaseOrderFromProject,
} from '../store/actions';
import { getAllPurchaseOrders } from 'actions/landlordPurchaseOrdersActions';

import ProjectDetails from '../components/ProjectDetails';

class MaintenanceProject extends Component {
  componentDidMount = () => {
    if (!featureEnabled('ui.maintenance.new_tickets_ui')) {
      browserHistory.push('/companies/dashboard');
    }
    if (!this.props.properties.length) {
      this.props.getProperties({ for_multiselect: true, show_cities: true });
    }

    const projectID = this.props.routeParams.projectID;
    if (projectID) {
      this.props.fetchProject(projectID);
      this.props.fetchFilteredProjectPurchaseOrders(projectID, 0, {});
    }
  };

  handleCloseProject = () => {};

  handleBack = () => {
    this.props.fetchProject(null);
    browserHistory.push('/companies/maintenance/projects');
  };

  fetchUnitsOfProperty = async property_id => {
    // Clear units and leases on reselection
    await this.props.showUnits([]);
    return this.props.getUnits(property_id, { for_multiselect: true });
  };

  linkPurchaseOrderToProject = (projectId, purchaseOrderId) => {
    return this.props.linkPurchaseOrderToProject(projectId, purchaseOrderId).then(() => {
      this.props.fetchFilteredProjectPurchaseOrders(projectId, 0, {});
    });
  };

  unlinkPurchaseOrderFromProject = (projectId, purchaseOrderId) => {
    return this.props.unlinkPurchaseOrderFromProject(projectId, purchaseOrderId).then(() => {
      this.props.fetchFilteredProjectPurchaseOrders(projectId, 0, {});
    });
  };

  render() {
    return (
      <ProjectDetails
        properties={this.props.properties}
        units={this.props.units}
        foundPurchaseOrders={this.props.foundPurchaseOrders}
        linkedPurchaseOrders={this.props.linkedPurchaseOrders}
        selectedProject={this.props.selectedProject}
        handleBack={this.handleBack}
        fetchFilteredProjectPurchaseOrders={this.props.fetchFilteredProjectPurchaseOrders}
        fetchUnitsOfProperty={this.fetchUnitsOfProperty}
        getAllPurchaseOrders={this.props.getAllPurchaseOrders}
        fetchProject={this.props.fetchProject}
        putProject={this.props.putProject}
        handleClose={this.handleCloseProject}
        linkPurchaseOrderToProject={this.linkPurchaseOrderToProject}
        unlinkPurchaseOrderFromProject={this.unlinkPurchaseOrderFromProject}
        fetchFilteredProjectTickets={this.props.fetchFilteredProjectTickets}
        tickets={this.props.tickets}
        linkTicketToProject={this.props.linkTicketToProject}
        unlinkTicketFromProject={this.props.unlinkTicketFromProject}
        currentLanguage={this.props.currentLanguage}
      />
    );
  }
}

const mapStateToProps = store => ({
  properties: store.landlordProperties.properties,
  units: store.landlordProperties.units,
  currentLanguage: store.locale.currentLanguage,
  selectedProject: store.landlord.maintenance.projects.selectedProject,
  tickets: store.landlord.maintenance.projects.tickets,
  isFetching: store.landlord.maintenance.projects.isFetching,
  foundPurchaseOrders: store.landlordPurchaseOrders.purchaseOrders,
  linkedPurchaseOrders: store.landlord.maintenance.projects.selectedProjectPurchaseOrders,
});

const mapDispatchToProps = {
  fetchProject,
  putProject,
  getProperties,
  getUnits,
  showUnits,
  getAllPurchaseOrders,
  fetchFilteredProjectPurchaseOrders,
  linkPurchaseOrderToProject,
  unlinkPurchaseOrderFromProject,
  fetchFilteredProjectTickets,
  linkTicketToProject,
  unlinkTicketFromProject,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MaintenanceProject));
